import { calcPlaceholderMultiSelect } from '@aytm/app/stats/page/question-views/components/lib/select-utils'

export const getStopWordLevelPlaceholder = (value, data) =>
  calcPlaceholderMultiSelect(value, data, {
    empty: 'Hide common English words',
    multiple: count => `Filtered to ${count}`
  })
